const breakpointImageUrls = function breakpointImageUrlsFunction(imageUrl) {
  let desktop;
  let mobile;
  const imageUrlExists = imageUrl.length > 0;
  const isBreakpointImage = RegExp('--desktop').test(imageUrl);

  if (!imageUrlExists) {
    return {
      desktop: '',
      mobile: '',
    };
  }

  if (!isBreakpointImage) {
    return {
      desktop: imageUrl,
      mobile: imageUrl,
    };
  }

  const cleanImageUrl = imageUrl.replace('--desktop', '');
  const imageExtensions = new RegExp(/(.jpg)|(.gif)|(.png)/);
  const hasImageExtension = imageExtensions.exec(cleanImageUrl);

  if (hasImageExtension) {
    const extensionIdx = hasImageExtension.index;
    const imageUrlPath = cleanImageUrl.substr(0, extensionIdx);
    const imageUrlExt = cleanImageUrl.substr(extensionIdx);

    desktop = `${imageUrlPath}--desktop${imageUrlExt}`;
    mobile = `${imageUrlPath}--mobile${imageUrlExt}`;
  }

  if (!hasImageExtension) {
    desktop = `${cleanImageUrl}--desktop.jpg`;
    mobile = `${cleanImageUrl}--mobile.jpg`;
  }

  return { desktop, mobile };
};

export default breakpointImageUrls;
